export default __webpack_public_path__ + "static/Royal-Stamp-logo-white-76caf67e1aebae730748414b8e6b3c4c.svg";